import { _ as _objectSpread2, b as _objectWithoutProperties } from '../../../_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var _excluded = ["proposerDetails", "proposerDetailsMeta"];
var init_state = {
  businessType: '',
  businessTypeValue: '',
  customerFetchRequiredOnLoad: false,
  productType: '',
  productTypeValue: '',
  isQuoteSaved: false,
  quoteData: null,
  coverData: null,
  quoteNumber: '',
  quoteStatus: '',
  quoteCreationDate: '',
  proposalNumber: '',
  policyNumber: '',
  proposalStatus: '',
  isProposalApplicableForPayment: null,
  isPolicyIssued: false,
  isExistingEmployee: '',
  isProposalReadyForRenewal: true,
  isProposalRenewed: false,
  isProposalRenewing: false,
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: '',
    intermediaryName: '',
    branchOfficeName: ''
  },
  proposerDetailsMeta: {
    crn: '',
    isNewCustomer: null,
    ifscCode: '',
    bankName: '',
    branchName: '',
    bankAcno: '',
    accountHolderName: '',
    micrCode: ''
  },
  proposerDetails: {
    id: '',
    customerType: '',
    title: '',
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fullName: '',
    occupation: '',
    maritalStatus: '',
    nationality: '',
    proposerDOB: '',
    panNumber: '',
    idProofType: '',
    idProofNumber: '',
    permAddressLine1: '',
    permAddressLine2: '',
    permAddressLine3: '',
    permLandmark: '',
    permPincode: '',
    permCityTownVillage: '',
    permDistrict: '',
    permState: '',
    permCommAddressYN: true,
    commAddressLine1: '',
    commAddressLine2: '',
    commAddressLine3: '',
    commLandmark: '',
    commPincode: '',
    commCityTownVillage: '',
    commDistrict: '',
    commState: '',
    mobileNo: '',
    emailID: '',
    orgName: '',
    orgType: '',
    contactName: '',
    regNumber: '',
    tanNumber: '',
    gstNumber: '',
    phoneNo: '',
    altPhoneNo: '',
    altMobileNo: '',
    faxNo: '',
    employeeNumber: ''
  },
  vehicleTabDetails: {
    vehicleRegistrationDetails: {
      registrationNumber: '',
      registrationNumberParts: {
        part1: '',
        part2: '',
        part3: '',
        part4: ''
      },
      isNewVehicle: false,
      engineNumber: '',
      chasisNumber: '',
      bodyIDV: '',
      totalIDV: ''
    },
    vehicleDetails: {
      make: {
        code: '',
        value: ''
      },
      model: {
        code: '',
        value: ''
      },
      variant: {
        code: '',
        value: ''
      },
      fuelType: '',
      cubeCapacity: '',
      seatingCapacity: '',
      yearOfManufacture: '',
      rtoDetails: {
        rtoAuthorityCode: '',
        rtoLocationCode: '',
        rtoLocationDesc: ''
      },
      dateOfRegistration: '',
      vehicleSegment: '',
      preInspectionNumber: ''
    },
    insuredDeclaredDetails: {
      vehicleIDV: null,
      irfAdjustmentPercent: '',
      idvPct: '',
      irfPct: '',
      sideCarPct: '',
      minChangedIDV: '',
      maxChangedIDV: '',
      sideCarValue: null,
      minSideCarValue: '',
      maxSideCarValue: ''
    }
  },
  additionalTabDetails: {
    previousInsuranceAndClaims: {
      previousPolicyDetails: {
        previousInsurerName: '',
        expiringPolicyNumber: '',
        policyCoverType: '',
        policyStartDate: '',
        policyExpiryDate: '',
        policyTenure: '',
        policyTenureValue: ''
      },
      previousClaims: {
        totalClaimCount: '',
        totalClaimCountValue: '',
        totalClaimAmount: '',
        previousYearNCBSlab: '',
        noOfClaimsYear1: '',
        noOfClaimsYear2: '',
        noOfClaimsYear3: ''
      }
    },
    nomineeDetails: {
      nomineeName: '',
      nomineeDob: '',
      relationshipWithNominee: '',
      nameOfAppointee: '',
      relationshipWithAppointee: ''
    },
    financeDetails: {
      vehicleOwned: '',
      financerDetails: {
        financerName: '',
        financerAddress: '',
        financerAgreementType: '',
        loanAccountNumber: '',
        fileNumber: ''
      }
    }
  },
  reviewAndConfirmTabDetails: {
    proposalPaymentType: '',
    leadGenerator: '',
    isProposalCreated: false
  },
  otherCoverDetails: {
    isGeoAreaExtension: false,
    isBangladeshCovered: false,
    isBhutanCovered: false,
    isMaldivesCovered: false,
    isNepalCovered: false,
    isPakistanCovered: false,
    isSriLankaCovered: false,
    isVehicleForHandicapped: false,
    isGlassFuelTank: false
  },
  policy: {
    startDate: '',
    endDate: '',
    time: ''
  },
  issuedPolicyData: {
    policyNo: '',
    receiptID: [],
    referenceNumber: '',
    digiLink: '',
    displayMessage: '',
    additionalMessage: ''
  },
  premiumData: {
    idv1: '',
    idv2: '',
    idv3: '',
    tenure: '',
    netODPremium: null,
    netTPPremium: null,
    loadingDiscount: null,
    netPremium: null,
    gst: null,
    stampDuty: null,
    totalPremium: null,
    loading: [],
    discount: [],
    vehicleAge: '',
    claimFreeYear: '',
    creditScore: ''
  },
  premiumDetails: {
    termsAndConditions: false,
    paymentMethod: '',
    payerType: '',
    onlinePayment: {
      transactionId: '',
      isTransactionIdVerified: null
    },
    cdWallet: {
      cdAccountNo: '',
      cdAccountBalance: ''
    },
    cheque: [],
    demandDraft: []
  }
};
var viewRenewMotorPolicyVar = makeVar(init_state);
var initViewRenewMotorPolicyVar = function initViewRenewMotorPolicyVar() {
  viewRenewMotorPolicyVar(init_state);
};
var resetProposerDetails = function resetProposerDetails(data) {
  var initObj = {},
      initMetaObj = {};
  Object.keys(viewRenewMotorPolicyVar().proposerDetails).forEach(function (v) {
    if (data !== null && data !== void 0 && data.proposerDetails[v]) {
      initObj[v] = data.proposerDetails[v];
    } else {
      if (v === 'permCommAddressYN') {
        initObj[v] = false;
      } else {
        initObj[v] = '';
      }
    }
  });
  Object.keys(viewRenewMotorPolicyVar().proposerDetailsMeta).forEach(function (v) {
    if (data !== null && data !== void 0 && data.proposerDetailsMeta[v]) {
      initMetaObj[v] = data.proposerDetailsMeta[v];
    } else {
      initMetaObj[v] = '';
    }
  });
  viewRenewMotorPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar()), {}, {
    proposerDetails: initObj,
    proposerDetailsMeta: initMetaObj
  }));
};
var updateViewRenewMotorPolicyVar = function updateViewRenewMotorPolicyVar(data) {
  var proposerDetails = data.proposerDetails,
      proposerDetailsMeta = data.proposerDetailsMeta,
      rest = _objectWithoutProperties(data, _excluded);

  if (proposerDetails && proposerDetailsMeta) {
    viewRenewMotorPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar().proposerDetails), proposerDetails),
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar().proposerDetailsMeta), proposerDetailsMeta)
    }, rest));
  } else if (proposerDetails && !proposerDetailsMeta) {
    viewRenewMotorPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar().proposerDetails), proposerDetails)
    }, rest));
  } else if (!proposerDetails && proposerDetailsMeta) {
    viewRenewMotorPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar()), {}, {
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar().proposerDetailsMeta), proposerDetails)
    }, rest));
  } else {
    viewRenewMotorPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar()), rest));
  }
};
var updatePaymentMethod = function updatePaymentMethod(data) {
  return viewRenewMotorPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar()), data));
};
var updateCheque = function updateCheque(data) {
  return viewRenewMotorPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewMotorPolicyVar()), {}, {
    cheque: data
  }));
};

export { initViewRenewMotorPolicyVar, resetProposerDetails, updateCheque, updatePaymentMethod, updateViewRenewMotorPolicyVar, viewRenewMotorPolicyVar };
